import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ProposalStatusService {

  private clearNewProposalIndicator: BehaviorSubject<boolean> = new BehaviorSubject(false);
  isClearNewProposalIndicator = this.clearNewProposalIndicator.asObservable();

  changeNewProposalIndicator(clearIndicator: boolean): void {
    this.clearNewProposalIndicator.next(clearIndicator);
  }
}
